import CashPoolingContainer from 'containers/cashPooling';

export default {
  exact: true,
  name: 'cash-pooling',
  protected: true,
  path: '/cash-pooling',
  component: CashPoolingContainer,
};
